import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import CinematicGardenEntrance from "./sections/CinematicGardenEntrance";
import ThePowerOfConnection from "./sections/ThePowerOfConnection";
import CuratedExperienceTiers from "./sections/CuratedExperienceTiers";
import CulinaryCuration from "./sections/CulinaryCuration";
import VisualNarrative from "./sections/VisualNarrative";
import TheSaborContinuum from "./sections/TheSaborContinuum";
import TheAfterPartySpotlight from "./sections/TheAfterPartySpotlight";
import CorporateAllies from "./sections/CorporateAllies";
import JoinTheMovement from "./sections/JoinTheMovement";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <CinematicGardenEntrance />
      <ThePowerOfConnection />
      <CuratedExperienceTiers />
      <CulinaryCuration />
      <VisualNarrative />
      <TheSaborContinuum />
      <TheAfterPartySpotlight />
      <CorporateAllies />
      <JoinTheMovement />
      <Footer />
    </div>;
}